// EduInInfo.js
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import * as d3 from 'd3'; // Import D3
import './EduInInfo.css';

function EduInInfo({ isEnglish }) {
  const location = useLocation();
  const item = location.state && location.state.item;

  console.log(item);
  const [schoolData, setSchoolData] = useState([]);

  const chartRef = useRef();

  // Declare maleFemaleStaffData and maleFemaleStudentsData
  const maleFemaleStaffData = [
    { label: isEnglish ? 'Male Staff' : 'पुरुष स्थानीय', value: item?.MALE_STAFF },
    { label: isEnglish ? 'Female Staff' : 'महिला स्थानीय', value: item?.FEMALE_STAFF },
  ];

  const maleFemaleStudentsData = [
    { label: isEnglish ? 'Male Students' : 'पुरुष विद्यार्थिनीहरू', value: item?.TOTAL_MALE_STUDENTS },
    { label: isEnglish ? 'Female Students' : 'महिला विद्यार्थिनीहरू', value: item?.TOTAL_FEMALE_STUDENTS },
  ];

  const library = [
    { label: isEnglish ? 'Library' : 'पुस्तकालय', value: item?.LIBRARY }
  ];
  
  const science_lab = [
    { label: isEnglish ? 'Science Lab' : 'विज्ञान प्रयोगशाला', value: item?.SCIENCE_LAB }
  ];
  
  const playground = [
    { label: isEnglish ? 'Playground' : 'खेलकूद क्षेत्र', value: item?.PLAYGROUND }
  ];
  
  const computer_lab = [
    { label: isEnglish ? 'Computer Lab' : 'कम्प्युटर प्रयोगशाला', value: item?.COMPUTER_LAB }
  ];
  
  const drinking_water = [
    { label: isEnglish ? 'Drinking Water' : 'पिउने पानी', value: item?.DRINKING_WATER }
  ];
  
  const buildings = [
    { label: isEnglish ? 'Buildings' : 'भवनहरू', value: item?.BUILDINGS }
  ];
  
  const classroom = [
    { label: isEnglish ? 'Class Room' : 'कक्षा', value: item?.CLASS_ROOM }
  ];
  
  const sanitation = [
    { label: isEnglish ? 'Sanitation' : 'सरसफाई', value: item?.SANITATION }
  ];
  

  const updateCharts = () => {
    createPieChart(maleFemaleStaffData, '.male-female-staff-chart');
    createPieChart(maleFemaleStudentsData, '.male-female-students-chart');
    createFacilitiesVisualization(library, '.facilities-chart-library');
    createFacilitiesVisualization(science_lab, '.facilities-chart-science-lab');
    createFacilitiesVisualization(playground, '.facilities-chart-playground');
    createFacilitiesVisualization(computer_lab, '.facilities-chart-computer-lab');
    createFacilitiesVisualization(drinking_water, '.facilities-chart-drinking-water');
    createFacilitiesVisualization(buildings, '.facilities-chart-buildings');
    createFacilitiesVisualization(classroom, '.facilities-chart-classroom');
    createFacilitiesVisualization(sanitation, '.facilities-chart-sanitation');
  };

  useEffect(() => {
    // Create the information visualization when the schoolData changes
    createInfoVisualization();
    updateCharts();
  }, [item, isEnglish]);

  const createInfoVisualization = () => {
    // General Info, Contact Info, Facilities Info (unchanged code)

    const educationStatisticsSection = (
      <div className="info-section">
        <h2>{isEnglish ? 'Educational Statistics' : 'शैक्षिक तथ्याङ्क'}</h2>
        <div className="pie-chart-container">
          <div className="pie-chart">
            <h3>{isEnglish ? 'Student Status' : 'विद्यार्थी स्थिति'}</h3>
            <div ref={(ref) => createPieChart(maleFemaleStaffData, ref)} className="male-female-staff-chart"></div>
            <div className='piechart-legend'>
              <div style={{ backgroundColor: '#1f77b4', height:"10px", width:"10px",borderRadius: '50%'}}></div>
              <p>{isEnglish ? 'Male' : 'पुरुष'}</p>
              <div style={{ backgroundColor: '#ff7f0e', height:"10px", width:"10px",borderRadius: '50%'}}></div>
              <p>{isEnglish ? 'Female' : 'महिला'}</p>
            </div>
          </div>
          <div className="pie-chart">
            <h3>{isEnglish ? 'Staff Status' : 'कर्मचारी स्थिति'}</h3>
            <div ref={(ref) => createPieChart(maleFemaleStudentsData, ref)} className="male-female-students-chart"></div>
            <div className='piechart-legend'>
              <div style={{ backgroundColor: '#1f77b4', height:"10px", width:"10px",borderRadius: '50%'}}></div>
              <p>{isEnglish ? 'Male' : 'पुरुष'}</p>
              <div style={{ backgroundColor: '#ff7f0e', height:"10px", width:"10px",borderRadius: '50%'}}></div>
              <p>{isEnglish ? 'Female' : 'महिला'}</p>
            </div>
          </div>
        </div>
        <div className="bar-container">
  <p>{isEnglish ? 'Attendance Rate:' : 'उपस्थिति दर:'}</p>
  <div className='bar-outer'>
    <div className="bar" style={{ '--bar-width': `${item?.ATTENDANCE_RATE}%` }}>
      {item?.ATTENDANCE_RATE}%
    </div>
  </div>
</div>

<div className="bar-container">
  <p>{isEnglish ? 'Pass out Rate:' : 'पास आउट दर:'}</p>
  <div className='bar-outer'>
    <div className="bar" style={{ '--bar-width': `${item?.PASS_FAIL_RATE}%` }}>
      {item?.PASS_FAIL_RATE}%
    </div>
  </div>
</div>

<div className="bar-container">
  <p>{isEnglish ? 'Drop Out Rate:' : 'छोड्ने दर:'}</p>
  <div className='bar-outer'>
    <div className="bar" style={{ '--bar-width': `${item?.DROP_OUT_RATE}%` }}>
      {item?.DROP_OUT_RATE}%
    </div>
  </div>
</div>

      </div>
    );

    const Facilities = (
      <div className="info-section">
        <h2>{isEnglish ? 'Facilities' : 'सुविधाहरू'}</h2>
        <div className='facility-container'>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(library, ref)} className="facilities-chart-library"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(science_lab, ref)} className="facilities-chart-science-lab"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(playground, ref)} className="facilities-chart-playground"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(computer_lab, ref)} className="facilities-chart-computer-lab"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(drinking_water, ref)} className="facilities-chart-drinking-water"></div>
          </div>
          {/* Add the new facilities here */}
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(buildings, ref)} className="facilities-chart-buildings"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(classroom, ref)} className="facilities-chart-classroom"></div>
          </div>
          <div className="facility">
            <div ref={(ref) => createFacilitiesVisualization(sanitation, ref)} className="facilities-chart-sanitation"></div>
          </div>
        </div>
      </div>
    );

    const scholorship = (
      <div className="info-section">
        <h2>{isEnglish ? 'Scholarship Scheme' : 'छात्रवृत्ति योजना'}</h2>
        <div className="scholarship">
          <p>{item?.SCHOLARSHIP_FINANCIAL_AID_ACTIVITIES}</p>
        </div>
      </div>
    );

    const achievement = (
      <div className="info-section">
        <h2>{isEnglish ? 'Achievement' : 'उपलब्धि'}</h2>
        <div className='achievement'>
          <p>{item?.ACHIEVEMENT}</p>
        </div>
      </div>
    );

    const content = (
      <div className="school-info">
        <div className="school-header-container">
          <div className='school-header'>
            <h3><i className="fas fa-school"></i> {item?.SCHOOL_NAME}-{item?.TYPE} school</h3>
            <h5><i className="fas fa-map-marker"></i> {item?.PALIKA}, {item?.WARD_NO}, {item?.VILLAGE_NAME} </h5>
            <h5><i className="far fa-clock"></i> {isEnglish ? 'Established Date' : 'स्थापित मिति'}: {item?.ESTD } BS</h5>
          </div>
          <div className='school-header'>
            <h5><i className="fas fa-user"></i> {isEnglish ? 'Contact Person' : 'सम्पर्क व्यक्ति'}: {item?.CONTACT_PERSON} </h5>
            <h5><i className="fas fa-phone"></i> {isEnglish ? 'Contact Number' : 'सम्पर्क नम्बर'}: {item?.CONTACT_NO} </h5>
          </div>
        </div>
        {educationStatisticsSection}
        {Facilities}
        {scholorship}
        {achievement}
      </div>
    );

    // Update the chart container with the content
    chartRef.current.innerHTML = ReactDOMServer.renderToString(content);
  };

  const createPieChart = (data, containerRef) => {
    const width = 200;
    const height = 200;
    const radius = Math.min(width, height) / 3;
  
    const svg = d3.select(containerRef)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${width / 2},${height / 2})`);
  
    // Define two distinct colors for the attributes
    const colors = ['#1f77b4', '#ff7f0e'];
  
    const pie = d3.pie().value(d => d.value);
    const arc = d3.arc().innerRadius(0).outerRadius(radius);
  
    const arcs = svg.selectAll('arc')
      .data(pie(data))
      .enter()
      .append('g')
      .attr('class', 'arc');
  
    arcs.append('path')
      .attr('d', arc)
      .attr('fill', 'transparent')
      .attr('stroke-width', 2)
      .each(function (d, i) {
        d3.select(this)
          .transition()
          .duration(1000)
          .attrTween('d', function (d) {
            const interpolate = d3.interpolateObject({ startAngle: 0, endAngle: 0 }, d);
            return t => arc(interpolate(t));
          })
          .attr('stroke', colors[i])
          .attr('fill', colors[i]); // Assign the color directly here
      });
  
    arcs.append('text')
      .attr('transform', d => `translate(${arc.centroid(d)})`)
      .attr('text-anchor', 'middle')
      .text(d => `${d.data.value}`);
  };
  
  const createFacilitiesVisualization = (facility, containerRef) => {
    console.log("inside facility");
    const width = 400;
    const height = 150;
    const radius = 30;

    const svg = d3.select(containerRef)
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    // Check if facility is defined before accessing its properties
    if (facility !== undefined) {
      const facilityCircles = svg.selectAll('circle')
        .data(facility)
        .enter()
        .append('circle')
        .attr('cx', width / 2)
        .attr('cy', height / 2)
        .attr('r', radius)
        .attr('fill', d => d.value ? 'green' : 'lightgray');
      
      // Add labels in the middle of the circles with three conditions
      const facilityLabels = svg.selectAll('text')
        .data(facility)
        .enter()
        .append('text')
        .attr('x', width / 2)
        .attr('y', height / 2 + 2 * radius)
        .attr('text-anchor', 'middle')
        .text(d => {
          if (d.value === true) {
            return d.label + ': Available';
          } else if  (d.value === false) {
            return d.label + ': Not Available';
          } else {
            return d.label + ': ' + d.value + " number";
          }
        });
    } else {
      // Handle the case where facility is undefined
      svg.append('circle')
        .attr('cx', width / 2)
        .attr('cy', height / 2)
        .attr('r', radius)
        .attr('fill', 'lightgray');

      svg.append('text')
        .attr('x', width / 2)
        .attr('y', height / 2 + 2 * radius)
        .attr('text-anchor', 'middle')
        .text(`${facility} not available`);
    }
  };

  return (
    <div className="edu-info-wrapper">
      <div ref={chartRef} className="edu-info-container"></div>
    </div>
  );
}

export default EduInInfo;
